import React from "react";

const Delete = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1293 4C10.4261 4 10.6667 4.23443 10.6667 4.52361L10.6644 4.57225L10.0734 10.745C9.93487 11.4805 9.44808 12 8.74182 12H3.37563C2.66937 12 2.08242 11.57 1.92238 10.745L1.33568 4.57228C1.30829 4.28414 1.52583 4.02892 1.82156 4.00223L1.87115 4C2.20362 4 2.47966 4.25014 2.50374 4.57322L2.87816 9.59716C2.95463 10.3514 3.16936 10.7079 3.52238 10.6667H8.44451C8.90923 10.6667 9.0297 10.2815 9.06935 9.9359L9.08217 9.79141L9.09291 9.6L9.49373 4.573C9.51951 4.24961 9.79637 4 10.1293 4ZM1.07973 0C1.11359 0 1.14732 0.00481047 1.18017 0.0143231L5.46415 1.25497L5.49917 1.09368C5.57818 0.729781 5.88045 0.498563 6.19487 0.546084L6.2917 0.569653C6.64489 0.689299 6.85331 1.10969 6.76391 1.52211L6.73615 1.65016L11.0283 2.9419C11.2462 3.00749 11.3769 3.2647 11.3201 3.51641C11.3134 3.54609 11.3042 3.57493 11.2927 3.60254C11.167 3.90304 10.8758 4.06015 10.5956 3.9786L1.18002 1.238C0.878207 1.15015 0.666687 0.836621 0.666687 0.477101C0.666687 0.213605 0.851611 0 1.07973 0Z"
        fill="#FD6759"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.14814 6C8.41084 6 8.62794 6.19507 8.6623 6.44816L8.66669 6.53754L8.4476 9.51951C8.42767 9.79039 8.20192 10 7.9301 10H4.12213C3.85378 10 3.62969 9.79553 3.60537 9.52848L3.33552 6.56551C3.30955 6.28032 3.51986 6.02809 3.80526 6.00213L3.82875 6.00053L8.14814 6Z"
        fill="#FD6759"
      />
    </svg>
  );
};

export default Delete;
